/**
 * Sayı alanının değişikliği (Mantine NumberInput): sayı geldiyse saklanır. Yazarken ara durumda
 * ("14.", "16.90", "-") dizgi gelir: ekranda yazıldığı gibi kalır, saklanan değer sayısal karşılığı
 * ya da boştur. Boş alan `null` (gövdeye girmez).
 */
export function numberInputChange(value: number | string): {
  stored: number | null;
  text: string | null;
} {
  if (typeof value === 'number') {
    return { stored: Number.isFinite(value) ? value : null, text: null };
  }
  if (value.trim() === '') return { stored: null, text: null };
  const parsed = Number(value);
  return { stored: Number.isFinite(parsed) ? parsed : null, text: value };
}
